import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiState } from "../../apis/index";
import { ApiEnrolledThing } from "../../apis/enrolledThing";
import { AppActions } from "../store";
import { UserHomeRepresentation } from "../../representations/userHome";

const _sliceName = 'userEnrolledThings';
const _initialState = {};

const UserEnrolledThingSlice = createSlice({
    name: _sliceName,
    initialState: { ..._initialState },
    reducers: {
        setLoading: (state, action) => {
            const { userId } = action.payload;
            const subState = ApiState.fromOb(state[userId])
            return {
                ...state,
                [userId]: subState.toLoading().toOb()
            };
        },
        setSuccess: (state, action) => {
            const { userId, data } = action.payload;
            const subState = ApiState.fromOb(state[userId])
            return {
                ...state,
                [userId]: subState.toComplete(data).toOb(),
            };
        },
        addEdge: (state, action) => {
            const { userId, homeId, edge } = action.payload;
            if (!state?.[userId]?.data?.[homeId]) {
                return;
            }
            let representation = UserHomeRepresentation.fromJSON({
                homeId,
                db: state?.[userId]?.data?.[homeId],
            });
            representation.injectEdge(edge);
            state[userId].data[homeId] = representation.toJSON();
        },
        removeEdge: (state, action) => {
            const { userId, homeId, edgeId } = action.payload;
            if (!state?.[userId]?.data?.[homeId]) {
                return;
            }
            let representation = UserHomeRepresentation.fromJSON({
                homeId,
                db: state?.[userId]?.data?.[homeId],
            });
            representation.ejectEdge(edgeId);
            state[userId].data[homeId] = representation.toJSON();
        },
        setError: (state, action) => {
            const { userId, error } = action.payload;
            const subState = ApiState.fromOb(state[userId])
            return {
                ...state,
                [userId]: subState.toError(error).toOb(),
            };
        },
    },
});


const UserEnrolledThingSliceRefreshThunk = createAsyncThunk(
    `${_sliceName}/refresh`,
    (userId, thunkApi) => {

        try {
            userId = userId || thunkApi.getState()?.auth?.user?._id;
            const dispatch = thunkApi.dispatch;
            dispatch(UserEnrolledThingSlice.actions.setLoading({ userId }));
            return ApiEnrolledThing.fetchAll().then((data) => {
                const edges = data.edges || [];
                const enrolledThings = data.enrolledThings || [];
                const inputs = data.inputs || [];
                const outputs = data.outputs || [];
                const relations = data.relations;
                dispatch(AppActions.db.updateList([
                    ...edges,
                    ...enrolledThings,
                    ...inputs,
                    ...outputs,
                ]));
                dispatch(AppActions.db.updateRelations(relations));

                try {
                    const homeInstances = {};

                    enrolledThings.forEach((enrolledThing) => {
                        const homeId = enrolledThing.home;
                        if (!homeInstances[homeId]) {
                            homeInstances[homeId] = new UserHomeRepresentation(homeId);
                        }
                        let representation = UserHomeRepresentation.cast(homeInstances[homeId]);
                        if (representation instanceof UserHomeRepresentation) {
                            representation.injectEnrolledThing(enrolledThing);
                            outputs.forEach((output) => {
                                representation.injectOutput(output);
                            });
                            inputs.forEach((input) => {
                                representation.injectInput(input);
                            });
                            edges.forEach((edge) => {
                                representation.injectEdge(edge);
                            })
                        }
                    });

                    for (let homeId in homeInstances) {
                        let home = homeInstances[homeId];
                        homeInstances[homeId] = home.toJSON();
                    }

                    dispatch(UserEnrolledThingSlice.actions.setSuccess({
                        userId: userId,
                        data: homeInstances,
                    }));

                } catch (e) {
                    console.log(e);
                }


            }).catch((err) => {
                dispatch(UserEnrolledThingSlice.actions.setError({
                    userId,
                    error: err + ""
                }));
            });

        } catch (e) {
            console.log(e);
        }


    },
);

export { UserEnrolledThingSlice, UserEnrolledThingSliceRefreshThunk }